export const LOCAL_STORAGE = {
  // cookies
  OTP_TOKEN: "otp-token",
  USER_NAME: "hrsol-user-name",
  AUTHORITIES: "hrsol-authorities",
  KEY_CHECK_TIME: "hrsol-key-check-time",
  CURRENT_REALM: "current-realm",
  DEFAULT_ORGANIZATION: "citynow-org",
  CURRENT_ORGANIZATION: "selected-org",
  // hrsol branch
  BRANCHES: "hrsol-branches",
  SELECTED_BRANCH: "selected-branch",
  // wf
  WF_BRANCHES: "wf-branches",
  SELECTED_BRANCH_WF: "selected-branch-wf",
  // org
  ORG_BRANCHES: "org-branches",
  SELECTED_BRANCH_ORG: "selected-branch-org",
};
